module.exports = __webpack_public_path__ + "media/images/icon__burger-menu-f67146033ab68676476518dcb9d70daf.png";